import {
  validateEnteredDate
} from '../utilities/utility';
$(function() {
  var monthtext = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  var monthValue = [
    '',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];
  function customDateNumber(num) {
    if (num <= 9) {
      return '0' + num;
    }
    return num;
  }
  function populatedropdown(day, month, year) {
    var today = new Date();
    var dayfield = document.getElementsByClassName(day);
    var monthfield = document.getElementsByClassName(month);
    var yearfield = document.getElementsByClassName(year);
    let yearDropdownLimit = 120;
    let yearDropdownUpperLimit = 121;

    for (var i = 1; i <= 31; i += 1) {
      dayfield[0].options[i] = new Option(i, customDateNumber(i));

      if (dayfield[1]) {
        dayfield[1].options[i] = new Option(i, customDateNumber(i));
      }
    }

    for (var m = 1; m <= 12; m += 1) {
      monthfield[0].options[m] = new Option(monthtext[m], monthValue[m]);

      if (monthfield[1]) {
        monthfield[1].options[m] = new Option(monthtext[m], monthValue[m]);
      }
    }

    if ($('#is-reorder-register-page').length > 0) {
      yearDropdownLimit = 100;
      yearDropdownUpperLimit = 101;
    }

    var thisyear = today.getFullYear() - yearDropdownLimit;

    for (var y = 1; y <= yearDropdownUpperLimit; y += 1) {
      yearfield[0].options[y] = new Option(thisyear, thisyear);

      if (yearfield[1]) {
        yearfield[1].options[y] = new Option(thisyear, thisyear);
      }
      thisyear += 1;
    }
  }

  function validateDate() {
    var ddlDay = $('#daydropdown_existing');
    var ddlMonth = $('#monthdropdown_existing');
    var ddlYear = $('#yeardropdown_existing');
    var date = new Date();
    var month = 0;
    switch (ddlMonth.val()) {
      case 'January':
        month = 1;
        break;
      case 'February':
        month = 2;
        break;
      case 'March':
        month = 3;
        break;
      case 'April':
        month = 4;
        break;
      case 'May':
        month = 5;
        break;
      case 'June':
        month = 6;
        break;
      case 'July':
        month = 7;
        break;
      case 'August':
        month = 8;
        break;
      case 'September':
        month = 9;
        break;
      case 'October':
        month = 10;
        break;
      case 'November':
        month = 11;
        break;
      case 'December':
        month = 12;
        break;
      default:
        month = 0;
    }

    var inputDate = ''
      .concat(ddlYear.val(), '-')
      .concat(month, '-')
      .concat(ddlDay.val() - 1);
    var parsedDate = ''
      .concat(date.getFullYear(), '-')
      .concat(date.getMonth() + 1, '-')
      .concat(date.getDate());
    var date1 = new Date(inputDate);
    var date2 = new Date(parsedDate);

    if (date1 > date2) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      return false;
    }
    $('.dateDrop').removeClass('error-msg-textbox');
    return true;
  }

  function validateLastName() {
    var name = /^[a-zA-Z0-9\s'-]+$/;
    var inputName = $('.existingUser_lastname').val();
    if ($('.existingUser_lastname').val() === '') {
      $('.error-msg-text-lastname').attr('hidden', false);
      $('.error-msg-text-invalidName').attr('hidden', true);
      $('.existingUser_lastname').addClass('error-msg-textbox');
    }
    if (!name.test(inputName)) {
      $('.error-msg-text-lastname').attr('hidden', true);
      $('.error-msg-text-invalidName').attr('hidden', false);
      $('.existingUser_lastname').addClass('error-msg-textbox');
    } else {
      $('.error-msg-text-lastname').attr('hidden', true);
      $('.error-msg-text-invalidName').attr('hidden', true);
      $('.existingUser_lastname').removeClass('error-msg-textbox');
    }
    return true;
  }

  function inValidInput(e) {
    if (!e.target.validity.valid) {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function validateUserInput(e) {
    e.preventDefault();
    if (!validateDate()) {
      return false;
    }
    if (!validateLastName()) {
      return false;
    }
    return true;
  }

  function additionalInputTextChange() {
    if ($("input[name ='accountInfoRadio']:checked").val() === 'policyNumber') {
      $('.existingUser_identificationText').prop(
        'placeholder',
        'Enter Insurance Member ID/ Policy Number'
      );
      $("input[name ='accountOrPolicyNumber']").val('');
      $('.js-registration-accountnumber')
        .parent()
        .hide();
      $('.js-registration-insurance')
        .parent()
        .show();
    } else if (
      $("input[name ='accountInfoRadio']:checked").val() === 'accountNumber'
    ) {
      $('.existingUser_identificationText').prop(
        'placeholder',
        'Enter account number'
      );
      $("input[name ='accountOrPolicyNumber']").val('');
      $('.js-registration-insurance')
        .parent()
        .hide();
      $('.js-registration-accountnumber')
        .parent()
        .show();
    }
  }

  function validateInput(e) {
    e.preventDefault();
    $(this)
      .next()
      .attr('hidden', true);
    $(this).removeClass('error-msg-textbox');
    $('.error-invalidDate').attr('hidden', true);
    if ($(this).val() === '') {
      e.preventDefault();
      $(this)
        .next()
        .attr('hidden', false);
      $(this).addClass('error-msg-textbox');
    }
  }

  function enableNextBtn(evt) {
    let dobText = $('#dateOfBirth_existing').val();
    let isValidDOB = validateEnteredDate(dobText);
    if(!isValidDOB && evt.target.id == 'dateOfBirth_existing'){
      $('#dateOfBirth_existing').addClass('error-msg-textbox');
      $('#dateOfBirth_existing').parent().find('.pattern-mismatch-text').attr('hidden', false);
    }
    if (
      $('.existingUser_identificationText').val() !== '' &&
      $('.existingUser_lastname').val() !== '' &&
      $('.existing-account-dob').val() !== '' &&
      $('.registration--form-dob').is(":visible") && 
      isValidDOB
    ) {
      $('#nextexistregister').prop('disabled', false);
    } else {
      $('#nextexistregister').prop('disabled', true);
    }
  }

  var elements1 = document.getElementsByClassName('existingUser_form__input');
  $.each(elements1, function(i, inputVal) {
    inputVal.addEventListener('invalid', inValidInput);
    inputVal.addEventListener('input', enableNextBtn);
  });

  if ($('.day').length > 0) {
    populatedropdown('daySelect', 'monthSelect', 'yearSelect');
  }

  $('.existingUser_form').on('submit', validateUserInput);
  $('.existingUser_identificationText').on('input', validateInput);
  $('.dateDrop').on('input', validateInput);
  $('.existingUser_lastname').on('input', validateLastName);
  $('.existingUser-radio').on('click', additionalInputTextChange);
  $('.radio_input').on('click', additionalInputTextChange);
  $('.existingUser_form__input').on('selectmenuchange', enableNextBtn);
});
